import { PLATFORM_TIMEZONE } from "../../utils/timezone";
import { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styles from "../../styles/__dialogHomeVisitPatientDetails.module.scss";
import MapImg from "../../assets/images/patientAddressMapModal.png";
import { MdOutlinePhone, MdOutlineCalendarMonth } from "react-icons/md";
import { TbLocation } from "react-icons/tb";
import { GoClock } from "react-icons/go";
import { IoChevronDownSharp } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { updateOnsiteScheduleReducer } from "../../reducer/updateOnsiteSchedule/updateOnsiteScheduleReducer";

export default function DialogHomeVisitPatientDetails({
  open,
  onClose,
  children,
  selectedData,
}) {
  const [date, setDate] = useState(new Date());
  const selectRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => {
      document.body.classList.remove("modal-open"); // cleanup
    };
  }, [open]);

  if (!open) return null;



  const openSelect = () => {
    if (selectRef.current) {
      selectRef.current.click(); // opens the dropdown
    }
  };

  const TIME_SLOTS = {
    morning: [
      "08:00 AM - 09:00 AM",
      "09:00 AM - 10:00 AM",
      "10:00 AM - 11:00 AM",
      "11:00 AM - 12:00 PM",
    ],
    afternoon: [
      "12:00 PM - 01:00 PM",
      "01:00 PM - 02:00 PM",
      "02:00 PM - 03:00 PM",
      "03:00 PM - 04:00 PM",
      "04:00 PM - 05:00 PM",
      "05:00 PM - 06:00 PM",
    ],
    evening: [
      "06:00 PM - 07:00 PM",
      "07:00 PM - 08:00 PM",
      "08:00 PM - 09:00 PM",
      "09:00 PM - 10:00 PM",
      "10:00 PM - 11:00 PM",
      "11:00 PM - 12:00 AM",
    ],
  };

  const selectedPeriod = selectedData?.appointment_time_slot?.toLowerCase();

  const timeSlots = TIME_SLOTS[selectedPeriod] || [];


const formatDateToYYYYMMDD = (date) => {
  if (!date) return "";

  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

 const formatTimeTo24Hour = (timeSlot) => {
  if (!timeSlot) return "";

  // Take start time only → "02:00 PM"
  const startTime = timeSlot.split("-")[0].trim();

  let [time, meridian] = startTime.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (meridian === "PM" && hours !== 12) {
    hours += 12;
  }

  if (meridian === "AM" && hours === 12) {
    hours = 0;
  }

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};

   const accept = () => {
    let dateData = formatDateToYYYYMMDD(date);
     let timeData = formatTimeTo24Hour(selectRef.current?.value)
    dispatch(
      updateOnsiteScheduleReducer({
        appointmentId: selectedData?.id,
        payload: {
          action: "accept",
          appointment_date: dateData,
          appointment_time: timeData,
          timezone: PLATFORM_TIMEZONE
        },
      })
    );
    onClose()
  };

    const reject = () => {
    dispatch(
      updateOnsiteScheduleReducer({
        appointmentId: selectedData?.id,
        payload: {
          action: "reject"
        },
      })
    );
    onClose()
  };

//   useEffect(() => {
//   if (selectRef.current) {
//     selectRef.current.value = "";
//   }
// }, [selectedPeriod]);

  return (
    <div className={styles["dialog-overlay"]}>
      <div className={styles["dialog-box"]}>
        {/* Close Button (X) */}
        <button className={styles["dialog-close"]} onClick={onClose}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.5525 12.0002L17.8525 7.71019C18.0408 7.52188 18.1466 7.26649 18.1466 7.00019C18.1466 6.73388 18.0408 6.47849 17.8525 6.29019C17.6642 6.10188 17.4088 5.99609 17.1425 5.99609C16.8762 5.99609 16.6208 6.10188 16.4325 6.29019L12.1425 10.5902L7.85252 6.29019C7.66421 6.10188 7.40882 5.99609 7.14252 5.99609C6.87622 5.99609 6.62082 6.10188 6.43252 6.29019C6.24421 6.47849 6.13843 6.73388 6.13843 7.00019C6.13843 7.26649 6.24421 7.52188 6.43252 7.71019L10.7325 12.0002L6.43252 16.2902C6.33879 16.3831 6.26439 16.4937 6.21363 16.6156C6.16286 16.7375 6.13672 16.8682 6.13672 17.0002C6.13672 17.1322 6.16286 17.2629 6.21363 17.3848C6.26439 17.5066 6.33879 17.6172 6.43252 17.7102C6.52548 17.8039 6.63608 17.8783 6.75794 17.9291C6.8798 17.9798 7.01051 18.006 7.14252 18.006C7.27453 18.006 7.40523 17.9798 7.52709 17.9291C7.64895 17.8783 7.75955 17.8039 7.85252 17.7102L12.1425 13.4102L16.4325 17.7102C16.5255 17.8039 16.6361 17.8783 16.7579 17.9291C16.8798 17.9798 17.0105 18.006 17.1425 18.006C17.2745 18.006 17.4052 17.9798 17.5271 17.9291C17.649 17.8783 17.7596 17.8039 17.8525 17.7102C17.9462 17.6172 18.0206 17.5066 18.0714 17.3848C18.1222 17.2629 18.1483 17.1322 18.1483 17.0002C18.1483 16.8682 18.1222 16.7375 18.0714 16.6156C18.0206 16.4937 17.9462 16.3831 17.8525 16.2902L13.5525 12.0002Z"
              fill="currentcolor"
            />
          </svg>
        </button>

        <div className={styles["dialogBody"]}>
          <div className={styles["mapWrapper"]}>
            <img src={MapImg} alt="" />
          </div>

          <div className={styles["patientDetails"]}>
            <div className={styles["patientInfoTop"]}>
              <div className={styles["patientProfile"]}>
                <div className={styles["patientTextInfo"]}>
                  <h3>{selectedData?.patient_name || "Rahul Rathi111"}</h3>
                  <div className={styles["iconText-wrap"]}>
                    <span className={styles["icon"]}>
                      <MdOutlinePhone />
                    </span>
                    <span>{selectedData?.patient_default_address?.name}</span>
                  </div>
                </div>
              </div>
              <button className={styles["greenOutline"]}>Get Direction</button>
            </div>

            <div className={styles["patientAddress"]}>
              <p className={styles["labelTxt"]}>Patient's Address</p>
              <div className={styles["iconText-wrap"]}>
                <span className={styles["icon"]}>
                  <TbLocation />
                </span>
                <span>
                  {selectedData?.patient_default_address?.house_flat_floor_no}{" "}
                  {selectedData?.patient_default_address?.area_district}{" "}
                  {selectedData?.patient_default_address?.street}{" "}
                  {selectedData?.patient_default_address?.city}{" "}
                  {selectedData?.patient_default_address?.governorate}{" "}
                  {selectedData?.patient_default_address?.country}
                </span>
              </div>
            </div>

            <div className={styles["prefDateNTime"]}>
              <div className={styles["prefDate"]}>
                <p className={styles["labelTxt"]}>PREFFERED DATE</p>
                <div className={styles["iconText-wrap"]}>
                  <span className={styles["icon"]}>
                    <MdOutlineCalendarMonth />
                  </span>
                  <span>{selectedData?.formatted_booking_date}</span>
                </div>
              </div>
              <div className={styles["prefTime"]}>
                <p className={styles["labelTxt"]}>PREFFERED TIME</p>
                <div className={styles["iconText-wrap"]}>
                  <span className={styles["icon"]}>
                    <GoClock />
                  </span>
                  <span>{selectedData?.appointment_time_slot}</span>
                </div>
              </div>
            </div>

            <div className={styles["appointDateNTime"]}>
              <p className={styles["labelTxt"]}>APPOINTMENT DATE AND TIME</p>

              <div className={styles["grid-wrapper"]}>
                <div className={styles["form-group"]}>
                  <MdOutlineCalendarMonth
                    className={styles["form-group-icon"]}
                  />
                  <div className={styles["labelWrapper"]}>
                    <label htmlFor="Date">Date</label>
                    <DatePicker
                      id="Date"
                      className={`${styles["input-field"]}`}
                      selected={date}
                      onChange={(d) => setDate(d)}
                    />
                  </div>
                  <div
                    className={`${styles["inputBtns"]} ${styles["lastItem"]}`}
                  >
                    <button>Today</button>
                    <button>Tomorrow</button>
                  </div>
                </div>

                <div className={styles["form-group"]} onClick={openSelect}>
                  <GoClock className={styles["form-group-icon"]} />
                  <div className={styles["labelWrapper"]}>
                    <label htmlFor="Time">Time</label>
                    {/* <select
                      id="Time"
                      ref={selectRef}
                      className={`${styles["input-field"]}`}
                       defaultValue="12:30 PM">
                        <option value="11:00 AM">11:00 AM</option>
                        <option value="11:30 AM">11:30 AM</option>
                        <option value="12:00 PM">12:00 PM</option>
                        <option value="12:30 PM">12:30 PM</option>
                    </select> */}
                    <select
                      id="Time"
                      ref={selectRef}
                      className={styles["input-field"]}
                      defaultValue=""
                    >
                      <option value="" disabled>
                        Select Time Slot
                      </option>

                      {timeSlots.map((slot) => (
                        <option key={slot} value={slot}>
                          {slot}
                        </option>
                      ))}
                    </select>
                  </div>
                  <IoChevronDownSharp
                    className={`${styles["form-group-icon"]} ${styles["lastItem"]}`}
                  />
                </div>
              </div>
            </div>

            <div className={styles["caseNote"]}>
              <p className={styles["labelTxt"]}>CASE NOTE</p>
              <p>{selectedData?.case_notes}</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          className={`${styles["dialog-footer"]}  ${styles["dialog-footer-btn-2"]}`}
        >
          <button className={`${styles["btn-danger"]}`} onClick={reject}>
            Reject
          </button>
          <button className={styles["btn-1"]} onClick={accept}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
